import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, PUBLIC, PUBLIC_JOBS } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/fetch-jobs-list`;

export const fetchPublicJobList = async (filters = {}) => {
  try {
    const token = await fetchToken();

    // Build query parameters
    const params = new URLSearchParams();

    // Add page parameter (default to 1 if not provided)
    if (filters.page) {
      params.append("page", filters.page);
    } else {
      params.append("page", "1");
    }

    // Add filters to params if they exist
    if (filters.experience) {
      params.append("experience", filters.experience);
    }

    if (filters.perPageCount) {
      params.append("perPageCount", filters.perPageCount);
    } else {
      params.append("perPageCount", "16"); // Default
    }

    if (filters.locations && filters.locations.length > 0) {
      params.append("locations", JSON.stringify(filters.locations));
    }

    if (filters.skills && filters.skills.length > 0) {
      params.append("skills", JSON.stringify(filters.skills));
    }

    if (filters.titles && filters.titles.length > 0) {
      params.append("titles", JSON.stringify(filters.titles));
    }

    if (filters.company && filters.company.length > 0) {
      params.append("company", JSON.stringify(filters.company));
    }

    if (filters.job_type) {
      params.append("job_type", filters.job_type);
    }

    if (filters.department_uuid) {
      params.append("department_uuid", filters.department_uuid);
    }

    if (filters.sort_by) {
      params.append("sort_by", filters.sort_by);
    }

    if (filters.salary_range) {
      params.append("salary_range", filters.salary_range);
    }

    const url = `${API_BASE_URL}?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
